<template>
    <div>
        <div class="tab-con">
            <van-nav-bar
                placeholder
                title="休假申请基础信息列表"
                fixed
            />
            <!-- <van-search
                v-model="searchValue"
                shape="round"
                background="#2d8cf0"
                placeholder="请输入搜索关键词"
            /> -->
            <div v-if="content != null && content != undefined && content != ''">
                <van-notice-bar
                left-icon="volume-o"
                :text="content"
            />
            </div>
            <van-dropdown-menu active-color="#1989fa">
                <van-dropdown-item v-model="applyStatus" :options="option1" @click.native="showApplyStatus" />
                <van-dropdown-item v-model="applyTime" :options="option2" @click.native="showApplyStatus"/>
            </van-dropdown-menu>
            <van-empty v-if="orderUndelivered.length === 0" description="暂无数据">
                <!-- <van-button round type="danger" class="bottom-button">按钮</van-button> -->
            </van-empty>
            <!-- 下拉刷新 -->
            <van-pull-refresh
                v-model="isLoading"
                success-text="刷新成功"
                @refresh="onRefresh"
            >
            <!-- 如果到底部以后，不允许再次刷新，注意以下写法 -->
            <!-- <van-pull-refresh
                v-model="isLoading"
                success-text="刷新成功"
                @refresh="onRefresh"
                :disabled='finished'
            > -->

                <!-- 上拉加载 -->
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :immediate-check="false"
                    loading-text="页面加载中"
                    :offset="300"
                    @load="onLoad"
                >
                <div v-if="orderUndelivered.length === 0" style="width: 290px; height: 500px;position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-10%);">
                    <div class="notNo">
                        <!-- E&nbsp;&nbsp;P&nbsp;&nbsp;S&nbsp;&nbsp;O&nbsp;&nbsp;N -->
                    </div>
                </div>
                <div v-for="(itemUndelivered, indexUndelivered) in orderUndelivered"
                        :key="indexUndelivered"   :id="itemUndelivered.applyStatusImg">
                    <van-cell value="查看" is-link  @click="seeDetail(itemUndelivered.id, true,true)" style="margin-top:8px">
                        <!-- 使用 title 插槽来自定义标题 -->
                        <template #title>
                            <span class="custom-title"> {{ itemUndelivered.applyNo }}</span>
                            <!-- <van-tag type="danger">标签</van-tag> -->
                        </template>
                    </van-cell>
                    <van-cell-group style="margin-top:2px;display: flex;flex-direction: column;text-align: left;padding-left: 15px;">
                        <!-- <van-cell title="用户名" value="内容">
                            <div style="float: left;">{{ itemUndelivered.username }}</div>
                        </van-cell>
                        <van-cell title="申请状态" value="内容">
                            <div style="float: left;">{{ itemUndelivered.applyStatusStr }}</div>
                        </van-cell>
                        <van-cell title="申请时间" value="内容">
                            <div style="float: left;">{{ itemUndelivered.createTime }}</div>
                        </van-cell> -->
                        <div style="padding-bottom: 5px;">用户账号：{{ itemUndelivered.username }}</div>
                        <div style="padding-bottom: 5px;">申请状态：{{ itemUndelivered.applyStatusStr }}</div>
                        <div style="padding-bottom: 5px;">申请时间：{{ itemUndelivered.createTime }}</div>
                        <div style="padding-bottom: 5px;">休假类别：{{ itemUndelivered.categoryStr }}/{{ itemUndelivered.classifyStr }}</div>
                        <van-image
                            style="width: 95px;
                            height: 95px;
                            position: absolute;
                            top: 50%;
                            left: 68%;
                            transform: translate(-10%,-50%);"
                            :src="itemUndelivered.img"
                        />
                    </van-cell-group>
                </div>
              </van-list>
            </van-pull-refresh>
        </div>
        <van-tabbar v-model="active" placeholder >
            <van-button block type="info" @click="addUserApplys()" native-type="submit">休假申请</van-button>
        </van-tabbar>
    </div>
</template>

<script>
    import {formatDate} from "@/unitls";
    // import {OrdersUndeliveryList} from "@/api/Order";
    import {getList} from "@/api/UserApply";
    import {getContent} from "@/api/SystemMessage";
    import { Cell } from "vant";
    import { Form } from 'vant';
    import { Field } from 'vant';
    import { NavBar } from 'vant';
    import { Popup } from 'vant'
    import { Picker } from 'vant';
    import { Panel } from 'vant';
    import { Tag } from 'vant';
    import { Image as VanImage } from 'vant';
    import { Search } from 'vant';
    import { PullRefresh } from 'vant';
    import { List } from 'vant';
    import { Empty } from 'vant';
    import { Tabbar, TabbarItem } from 'vant';
    import Vue from 'vue';
    Vue.use(Form);
    Vue.use(Field);
    Vue.use(Cell);
    Vue.use(Popup);
    Vue.use(Picker);
    Vue.use(NavBar);
    Vue.use(Panel);
    Vue.use(Tag);
    Vue.use(VanImage);
    Vue.use(Search);
    Vue.use(PullRefresh);
    Vue.use(List);
    Vue.use(Empty);
    Vue.use(Tabbar);
    Vue.use(TabbarItem);

    export default {
        name: "OrderUndelivered",

        data() {
            return {
                //检索参数
                sortSelect: 0,
                searchKeyword: '',
                applyStatusStr: '',
                testUrl: '',
                active: 0,
                content:'',
                orderSortSelectItem: [
                    {
                        id: this.$ORDER_SORT_TYPE.TIME_ABNORMAL,
                        sortName: '时间倒序'
                    },
                    {
                        id: this.$ORDER_SORT_TYPE.TIME_NORMAL,
                        sortName: '时间正序'
                    },
                    {
                        id: this.$ORDER_SORT_TYPE.ADDRESS,
                        sortName: '地址排序'
                    }
                ],
                applyStatus: 0,
                applyTime: '0',
                option1: [
                    { text: '申请状态', value: 0 },
                    { text: '申请中', value: 1 },
                    { text: '审批通过', value: 2 },
                    { text: '申请异常', value: 3 },
                    { text: '用户取消', value: 4 },
                    { text: '审批中', value: 5 },
                    { text: '审批拒绝', value: 6 },
                ],
                option2: [
                    { text: '默认排序', value: '0' },
                    { text: '时间倒序', value: '1' },
                    { text: '时间正序', value: '2' },
                ],
                searchValue: '',
                //列表page和limit
                orderUndeliveredPage: this.$REQUEST_PAGE_LIMIT.PAGE,
                orderUndeliveredTotal: '',
                //订单列表数据
                orderUndelivered: [],
                isLoading: false, //下拉刷新
                loading: false, //上拉加载
                finished: false, //加载与不加载的状态
                // 上拉加载的设置
                infiniteLoadData: {
                    initialShowNum: this.$REQUEST_PAGE_LIMIT.LIMIT, // 初始显示多少条
                    everyLoadingNum: this.$REQUEST_PAGE_LIMIT.LIMIT, // 每次加载的个数
                    orderUndeliveredPullUpState: 1, // 子组件的pullUpState状态
                    showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
                },
            }
        },

        created() {
            this.selectContent();
            this.sortSelect = this.orderSortSelectItem[0].id
        },

        mounted() {
            this.orderUndeliveredPage = 1;
            this.requestUndeliveryList();
        },

        methods: {
            selectContent(){
                getContent(1)
                    .then((response) => {
                       this.content =  response.data.content;
                    })
            },
            //检索
            searchOrder() {
                this.orderUndeliveredPage = 1;
                this.infiniteLoadData.orderUndeliveredPullUpState = 1;
                this.requestUndeliveryList()
            },
            addUserApplys(){
                this.$router.push({path: '/userApplyMenu'})
            },
            step:function(i){
                return 'a'+i
            },
            //未配送列表
            async requestUndeliveryList() {
                await getList(this.searchKeyword, this.applyStatus,this.applyTime, this.orderUndeliveredPage, this.infiniteLoadData.initialShowNum)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            //将接口返回赋值data定义的数组
                            this.orderUndelivered = [];
                            //将接口返回的总数据条数赋值data中定义的total
                            // this.orderUndeliveredTotal = response.data.total;
                            response.data.forEach((item) => {
                                // var index = item.applyStatus;
                                // this.testUrl = require('../../assets/' + index + '.png')
                                this.orderUndeliveredTotal = item.total;
                                this.orderUndelivered.push({
                                    id: item.seqId,
                                    applyNo: item.applyNo,
                                    applyStatus: item.applyStatus,
                                    applyStatusStr: item.applyStatusStr,
                                    username: item.username,
                                    account: item.account,
                                    createTime: formatDate(item.createTime, 'yyyy-MM-dd hh:mm:ss'),
                                    timeout: item.timeout,
                                    urgent: item.urgent,
                                    companyFlag: item.companyFlag,
                                    freed: item.freed,
                                    errorMsg: item.errorMsg,
                                    categoryStr: item.categoryStr,
                                    classifyStr: item.classifyStr,
                                    img : require('../../assets/' + item.applyStatus + '.png')
                                })
                            });
                            this.loading = false;
                            //如果查询结果为空
                            if (this.orderUndelivered.length == 0) {
                                this.finished = true;
                                this.loading = true;
                                return;
                            }
                            //将返回数据长度与总条数进行比较控制加载不加载的状态
                            if (this.orderUndelivered.length >= this.orderUndeliveredTotal) {
                                this.finished = true;
                                this.loading = true;
                                return;
                            }
                        }
                    })
            },

            //上拉加载
            onLoad() {
                this.orderUndeliveredPage++;
                // console.log("当前页数:" + this.orderUndeliveredPage)
                getList(this.searchKeyword, this.applyStatus, this.applyTime, this.orderUndeliveredPage, this.infiniteLoadData.initialShowNum)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            //将接口返回赋值data定义的数组
                            this.orderUndelivered1 = [];
                            //将接口返回的总数据条数赋值data中定义的total
                            // this.orderUndeliveredTotal = response.data;
                            response.data.forEach((item) => {
                                // var index = item.applyStatus;
                                // this.testUrl = require('../../assets/' + index + '.png')
                                this.orderUndeliveredTotal = item.total;
                                this.orderUndelivered1.push({
                                    id: item.seqId,
                                    applyNo: item.applyNo,
                                    applyStatus: item.applyStatus,
                                    applyStatusStr: item.applyStatusStr,
                                    username: item.username,
                                    account: item.account,
                                    createTime: formatDate(item.createTime, 'yyyy-MM-dd hh:mm:ss'),
                                    timeout: item.timeout,
                                    urgent: item.urgent,
                                    companyFlag: item.companyFlag,
                                    freed: item.freed,
                                    errorMsg: item.errorMsg,
                                    categoryStr: item.categoryStr,
                                    classifyStr: item.classifyStr,
                                    img : require('../../assets/' + item.applyStatus + '.png')
                                })
                            });
                            // this.orderUndelivered = [...this.orderUndelivered1, ...this.orderUndelivered]
                            this.orderUndelivered = [...this.orderUndelivered, ...this.orderUndelivered1]
                            // console.log(this.orderUndelivered.length)
                            // 加载状态结束 状态更新为false
                            this.loading = false;
                            //将返回数据长度与总条数进行比较控制加载不加载的状态
                            // console.log("数据集合:" + this.orderUndelivered)
                            //如果查询结果为空
                            if (this.orderUndelivered.length == 0) {
                                this.finished = true;
                                this.loading = true;
                                return;
                            }
                            if (this.orderUndelivered.length >= this.orderUndeliveredTotal) {
                                this.finished = true;
                                this.loading = true;
                                return;
                            }
                        }
                    })
            },
            //下拉刷新
            onRefresh() {
                this.orderUndeliveredPage = 1; //起始为第一页
                this.finished = false;//加载与不加载的状态
                this.orderUndelivered = [];
                setTimeout(() => {
                    this.isLoading = false; //下拉刷新状态
                    this.requestUndeliveryList() //刷新成功调用列表方法
                    this.$toast('刷新成功'); //轻提示信息
                }, 700);
            },

            onSearch(val) {
                this.toast(val);
            },
            onCancel() {
                this.toast('取消');
            },
            seeDetail(orderId, isShow, type) {
                if (type) {
                    this.$router.push({path: '/userApplyDetail', query: {orderId, isShow}})
                } else {
                    this.$router.push({path: '/orderDetail', query: {orderId, isShow}});
                }

            },
            showApplyStatus() {
                this.orderUndelivered = [];
                this.orderUndeliveredPage = 1;
                this.finished = false;//加载与不加载的状态
                this.requestUndeliveryList();
            },
            onClickLeft() {
                this.$router.go(-1);
            }
        },

        // activated() {
        //     this.orderUndeliveredPage = 1;
        //     this.infiniteLoadData.orderUndeliveredPullUpState = 1;
        //     this.requestUndeliveryList();
        // }  
    }
</script>

<style scoped lang="scss">
    div /deep/ .van-cell:after {
        border: none;
    }
    [class*="van-hairline"]::after {
        border: none;
    }
    .van-cell__title{   /* sass 修改子组件样式  /deep/ 或者 >>> */
        text-align: left;
    }
    custom-title {
        text-align: left;
    }
    /* .notNo{
        background-image: url('../../assets/epson.png');
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        font-size: 50PX;
        color: blue;
    }
    #addCSS{
        width: 100%;
        height: 50PX;
        background-color:#2d8cf0;
        font-size: 20PX;
        color: #FFFFFF;
        right: 0;
        bottom: 0;
        left: 0;
        position: fixed;
        z-index: 1;
    } */
</style>